// extracted by mini-css-extract-plugin
module.exports = {"mapBuoyCards":"MapBuoyCards_mapBuoyCards__XunMT"};